// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.restore-point-modal_modal-content_ngXcZ {
    max-width: 600px;
    margin-top: 50px;
}

.restore-point-modal_body_Vs0QP {
    background: var(--ui-modal-background);
    padding: 1.5rem 2.25rem;
    max-height: calc(100vh - 150px);
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.restore-point-modal_extra-container_SR_Vv {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.restore-point-modal_total-size_futE7 {

}

.restore-point-modal_total-size-description_y1i4j {
    font-size: small;
}

.restore-point-modal_button_Fehhw {
    font: inherit;
    color: inherit;
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    border: 1px solid var(--ui-black-transparent);
    font-weight: 600;
    font-size: 0.85rem;
    color: var(--ui-white);
}

.restore-point-modal_button_Fehhw:disabled {
    opacity: 0.8;
}

.restore-point-modal_delete-all-button_EPKIp {
    margin-left: 1rem;
    background-color: var(--data-primary);
    color: white;
    white-space: nowrap;
}

.restore-point-modal_error-message_EOF2E {
    font-family: monospace;
    -webkit-user-select: text;
       -moz-user-select: text;
        -ms-user-select: text;
            user-select: text;
}

.restore-point-modal_restore-point-container_zIDTz {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.5rem;
}

.restore-point-modal_restore-point_zLL7T {
    width: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    border: 2px solid var(--ui-black-transparent);
    padding: 0.5rem;
    border-radius: 0.5rem;
    gap: 0.5rem;
}

.restore-point-modal_restore-point_zLL7T:hover {
    border-color: var(--looks-secondary);
}

.restore-point-modal_restore-point-title_yO55R {
    font-weight: bold;
}

.restore-point-modal_thumbnail-container_vXvCx {
    flex-shrink: 0;
    /* 4:3 */
    width: 100px;
    height: 75px;
}

.restore-point-modal_thumbnail-image_KmF8c {
    display: block;
    border-radius: 0.25rem;
    width: 100%;
    height: 100%;
}

.restore-point-modal_thumbnail-placeholder_JQkGc {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2em;
}

.restore-point-modal_restore-point-buttons_zaDzX {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
}

.restore-point-modal_restore-point-button_S1l8I {
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    background: none;
    border: none;
    border-radius: 100%;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.restore-point-modal_restore-point-button_S1l8I[disabled] {
    opacity: 0.5;
}

.restore-point-modal_restore-point-button_S1l8I img {
    display: block;
    width: 75%;
    height: 75%;
    filter: var(--filter-icon-gray);
}

.restore-point-modal_restore-point-button_S1l8I:not([disabled]):hover {
    background-color: var(--ui-black-transparent);
}

.restore-point-modal_disabled_Ox_iL {
    padding: 0.5rem;
    border-radius: 0.5rem;
    background-color: rgba(255, 0, 0, 0.18);
    border: 2px solid rgba(255, 0, 0, 0.568);
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-restore-point-modal/restore-point-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;IACvB,+BAA+B;IAC/B,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;AAEA;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,sBAAsB;IACtB,6CAA6C;IAC7C,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,6CAA6C;IAC7C,eAAe;IACf,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;IACxB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,uCAAuC;IACvC,wCAAwC;IACxC,iBAAiB;AACrB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n    max-width: 600px;\n    margin-top: 50px;\n}\n\n.body {\n    background: var(--ui-modal-background);\n    padding: 1.5rem 2.25rem;\n    max-height: calc(100vh - 150px);\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.extra-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.total-size {\n\n}\n\n.total-size-description {\n    font-size: small;\n}\n\n.button {\n    font: inherit;\n    color: inherit;\n    padding: 0.75rem 1rem;\n    border-radius: 0.25rem;\n    border: 1px solid var(--ui-black-transparent);\n    font-weight: 600;\n    font-size: 0.85rem;\n    color: var(--ui-white);\n}\n\n.button:disabled {\n    opacity: 0.8;\n}\n\n.delete-all-button {\n    margin-left: 1rem;\n    background-color: var(--data-primary);\n    color: white;\n    white-space: nowrap;\n}\n\n.error-message {\n    font-family: monospace;\n    -webkit-user-select: text;\n       -moz-user-select: text;\n        -ms-user-select: text;\n            user-select: text;\n}\n\n.restore-point-container {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n}\n\n.restore-point {\n    width: 100%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    border: 2px solid var(--ui-black-transparent);\n    padding: 0.5rem;\n    border-radius: 0.5rem;\n    gap: 0.5rem;\n}\n\n.restore-point:hover {\n    border-color: var(--looks-secondary);\n}\n\n.restore-point-title {\n    font-weight: bold;\n}\n\n.thumbnail-container {\n    flex-shrink: 0;\n    /* 4:3 */\n    width: 100px;\n    height: 75px;\n}\n\n.thumbnail-image {\n    display: block;\n    border-radius: 0.25rem;\n    width: 100%;\n    height: 100%;\n}\n\n.thumbnail-placeholder {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 2em;\n}\n\n.restore-point-buttons {\n    margin-left: auto;\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n}\n\n.restore-point-button {\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    background: none;\n    border: none;\n    border-radius: 100%;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.restore-point-button[disabled] {\n    opacity: 0.5;\n}\n\n.restore-point-button img {\n    display: block;\n    width: 75%;\n    height: 75%;\n    filter: var(--filter-icon-gray);\n}\n\n.restore-point-button:not([disabled]):hover {\n    background-color: var(--ui-black-transparent);\n}\n\n.disabled {\n    padding: 0.5rem;\n    border-radius: 0.5rem;\n    background-color: rgba(255, 0, 0, 0.18);\n    border: 2px solid rgba(255, 0, 0, 0.568);\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `restore-point-modal_modal-content_ngXcZ`,
	"modalContent": `restore-point-modal_modal-content_ngXcZ`,
	"body": `restore-point-modal_body_Vs0QP`,
	"extra-container": `restore-point-modal_extra-container_SR_Vv`,
	"extraContainer": `restore-point-modal_extra-container_SR_Vv`,
	"total-size": `restore-point-modal_total-size_futE7`,
	"totalSize": `restore-point-modal_total-size_futE7`,
	"total-size-description": `restore-point-modal_total-size-description_y1i4j`,
	"totalSizeDescription": `restore-point-modal_total-size-description_y1i4j`,
	"button": `restore-point-modal_button_Fehhw`,
	"delete-all-button": `restore-point-modal_delete-all-button_EPKIp`,
	"deleteAllButton": `restore-point-modal_delete-all-button_EPKIp`,
	"error-message": `restore-point-modal_error-message_EOF2E`,
	"errorMessage": `restore-point-modal_error-message_EOF2E`,
	"restore-point-container": `restore-point-modal_restore-point-container_zIDTz`,
	"restorePointContainer": `restore-point-modal_restore-point-container_zIDTz`,
	"restore-point": `restore-point-modal_restore-point_zLL7T`,
	"restorePoint": `restore-point-modal_restore-point_zLL7T`,
	"restore-point-title": `restore-point-modal_restore-point-title_yO55R`,
	"restorePointTitle": `restore-point-modal_restore-point-title_yO55R`,
	"thumbnail-container": `restore-point-modal_thumbnail-container_vXvCx`,
	"thumbnailContainer": `restore-point-modal_thumbnail-container_vXvCx`,
	"thumbnail-image": `restore-point-modal_thumbnail-image_KmF8c`,
	"thumbnailImage": `restore-point-modal_thumbnail-image_KmF8c`,
	"thumbnail-placeholder": `restore-point-modal_thumbnail-placeholder_JQkGc`,
	"thumbnailPlaceholder": `restore-point-modal_thumbnail-placeholder_JQkGc`,
	"restore-point-buttons": `restore-point-modal_restore-point-buttons_zaDzX`,
	"restorePointButtons": `restore-point-modal_restore-point-buttons_zaDzX`,
	"restore-point-button": `restore-point-modal_restore-point-button_S1l8I`,
	"restorePointButton": `restore-point-modal_restore-point-button_S1l8I`,
	"disabled": `restore-point-modal_disabled_Ox_iL`
};
export default ___CSS_LOADER_EXPORT___;
